"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _section = _interopRequireDefault(require("@site/pattern-library-core/section"));
var _siteSearchContext = require("../../page-body/site-search-results/site-search-context");
var _index = _interopRequireDefault(require("../../page-body/site-search-results/search-bar/index"));
var _tag = _interopRequireDefault(require("@site/pattern-library-core/tag"));
var _functions = require("../../page-body/site-search-results/utils/functions");
var _productListingContext = require("../../elements/other/product-list-page/product-listing-context");
var _unifiedSearchTileGrid = _interopRequireDefault(require("./unified-search-tile-grid"));
var _filterNav = _interopRequireDefault(require("../../page-body/site-search-results/filter-nav"));
var _searchHeadline = _interopRequireDefault(require("../../page-body/site-search-results/search-headline"));
var _autocomplete = require("./hooks/autocomplete");
var _search = require("./hooks/search");
var _handleOnConfirm = require("./hooks/handle-on-confirm");
var _useSearch = require("./hooks/use-search");
var _searchContext = require("./hooks/search-context");
var _useDomainSearch = require("./hooks/use-domain-search");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const SiteSearchPageContainer = /*#__PURE__*/(0, _react2.styled)(_section.default)({
  name: "SiteSearchPageContainer",
  class: "pl-siirbuz"
});
const SearchBarContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "SearchBarContainer",
  class: "pl-s19i5j9s"
});
const Content = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Content",
  class: "pl-c1jdmsyc"
});
const ProductListingPageContainer = /*#__PURE__*/(0, _react2.styled)("section")({
  name: "ProductListingPageContainer",
  class: "pl-p1nu6rrn"
});
const ResultsContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ResultsContainer",
  class: "pl-r1vfohrw"
});
const getNavLinksFromTags = tag => {
  const sharedData = {
    reactInit: 'Universal',
    templateName: 'FilterNavLink'
  };
  return {
    ...sharedData,
    ariaLabel: tag.value,
    filterText: tag.value,
    filterKey: tag.key,
    _name: tag.key
  };
};

/**
 * Internal component that uses the search context
 * This component contains all the search logic and rendering
 * @returns {React.ReactElement} UnifiedSearchInternal component
 */
function UnifiedSearchInternal({
  placeholder,
  clearAriaLabel,
  popularListLabel,
  suggestionsListLabel,
  resultsListLabel,
  noResultsListLabel,
  resultsExternalPaths,
  searchBanner,
  suggestedSearchesHeadline,
  aiPoweredTagText
}) {
  const context = (0, _searchContext.useInternalSearch)();
  const {
    isLoading: searchDataIsLoading,
    searchData
  } = (0, _useDomainSearch.useDomainSearch)();
  const tileGridRef = (0, _react.useRef)(null);
  const autocomplete = (0, _autocomplete.useAutocomplete)();
  const search = (0, _search.useSearch)();
  const handleOnConfirm = (0, _handleOnConfirm.useHandleOnConfirm)(search);

  // Use search effects with simplified parameters
  (0, _useSearch.useSearchEffects)(autocomplete, handleOnConfirm);
  const searchBarProps = {
    autocompleteEndpoint: context.autocompleteEndpoint,
    placeholder,
    clearAriaLabel,
    popularListLabel,
    suggestionsListLabel,
    resultsListLabel,
    noResultsListLabel
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_siteSearchContext.SiteSearchContext.Provider, {
    value: {
      ...context,
      autocomplete,
      searchBanner,
      resultsExternalPaths,
      suggestedSearchesHeadline,
      handleOnConfirm,
      highlightKeyword: _functions.highlightKeyword,
      searchData,
      searchDataIsLoading
    }
  }, /*#__PURE__*/_react.default.createElement(SiteSearchPageContainer, {
    dataCy: "unified-search"
  }, /*#__PURE__*/_react.default.createElement(SearchBarContainer, null, /*#__PURE__*/_react.default.createElement(_index.default, (0, _extends2.default)({
    id: "site.search.bar"
  }, searchBarProps, {
    trackingV2: true
  }))), /*#__PURE__*/_react.default.createElement(ResultsContainer, null, aiPoweredTagText && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_tag.default, {
    style: {
      fontSize: '0.79rem'
    },
    text: aiPoweredTagText,
    design: 'info'
  })), context.searchValue && /*#__PURE__*/_react.default.createElement(_searchHeadline.default, {
    headlineTemplate: "Search Results for \"{{searchValue}}\""
  }), context.availableTags && /*#__PURE__*/_react.default.createElement(_filterNav.default, {
    allText: "ALL",
    filterNavLinks: context.availableTags.map(getNavLinksFromTags)
  })))), /*#__PURE__*/_react.default.createElement(_productListingContext.ProductListingContext.Provider, {
    value: {
      isActiveTagFilter: context.activeFilter !== 'all',
      tagFilterValue: context.activeFilter
    }
  }, /*#__PURE__*/_react.default.createElement(ProductListingPageContainer, null, context.results && /*#__PURE__*/_react.default.createElement(Content, null, /*#__PURE__*/_react.default.createElement(_unifiedSearchTileGrid.default, {
    results: context.results,
    iaMarkdown: context.markdown,
    isLoading: context.isLoading,
    tileGridRef: tileGridRef,
    containerHeight: context.containerHeight
  })))));
}
UnifiedSearchInternal.propTypes = {
  placeholder: _propTypes.default.string.isRequired,
  clearAriaLabel: _propTypes.default.string,
  popularListLabel: _propTypes.default.string.isRequired,
  suggestionsListLabel: _propTypes.default.string.isRequired,
  resultsListLabel: _propTypes.default.string.isRequired,
  noResultsListLabel: _propTypes.default.string.isRequired,
  resultsExternalPaths: _propTypes.default.string.isRequired,
  searchBanner: _propTypes.default.object,
  suggestedSearchesHeadline: _propTypes.default.string.isRequired,
  aiPoweredTagText: _propTypes.default.string
};
var _default = exports.default = UnifiedSearchInternal;